import { useEffect } from 'react';

const GTM_ID = 'GTM-NZWR9M3';

export default function GoogleTagManagerPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') {return;}
    if (localStorage.getItem('cookieConsent') === 'accepted' && !window.gtmLoaded) {
      window.gtmLoaded = true;
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
      document.head.appendChild(script);
    }
  }, []);

  return null;
}
